<template>
  <div>
    <div class="loading-state-container" v-if="loadCommentState.isLoading">
      <div class="container">
        <PreloaderSection />
      </div>
    </div>
    <div v-if="!loadCommentState.isLoading">
      <Page>
        <template v-slot:page-header>
          <div class="container">
            <div class="page-header">
              <router-link
                class="btn btn-action btn-action-back"
                :to="`/comments`">
                <i class="fas fa-chevron-left" />
              </router-link>
              <div class="title-container">
                <div class="title">{{ getCommentCategoryName() }}</div>
                <div class="subtitle medium-device">จาก {{ comment.email }}</div>
                <div class="submitted-time-xs">ส่งเมื่อ {{formatDateTime(comment.submittedAt)}}</div>
              </div>
              <div class="actions">
                <div class="submitted-time">ส่งเมื่อ {{formatDateTime(comment.submittedAt)}}</div>
              </div>
            </div>
          </div>
        </template>
        <div class="container">
          <div class="section-container">
            <Section>
              <template v-slot:section-header>
                <h5 class="title">รายละเอียด</h5>
              </template>
              <template v-slot:section-body>
                <div class="comment-container">
                  <div class="row">
                    <div class="col-md-7">
                      <div class="comment-item-container">
                        <div class="comment-item-header">ชื่อผู้เขียน</div>
                        <div class="comment-item-detail">
                          {{ comment.fullName }}
                        </div>
                      </div>
                      <div class="comment-item-container small-device">
                        <div class="comment-item-header">อีเมลผู้เขียน</div>
                        <div class="comment-item-detail">
                          {{ comment.email }}
                        </div>
                      </div>
                      <div class="comment-item-container medium-device">
                        <div class="comment-item-header">ความคิดเห็น</div>
                        <div class="comment-item-detail">
                          {{ comment.comment }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div class="comment-item-container">
                        <div class="comment-item-header">รายการ</div>
                        <div class="comment-item-detail">
                          {{ getProgramTitle() ? getProgramTitle() : 'ไม่ระบุ' }}
                        </div>
                      </div>
                      <div class="comment-item-container">
                        <div class="comment-item-header">หมวดหมู่คอนเทนท์</div>
                        <div class="comment-item-detail">
                          {{ getProgramCategoryName() ? getProgramCategoryName() : 'ไม่ระบุ' }}
                        </div>
                      </div>
                      <div class="comment-item-container" v-if="comment.mailMessages">
                        <div class="comment-item-header">
                          สถานะการส่งอีเมล
                        </div>
                        <div class="comment-item-detail">
                          <div class="mail-item-container"
                            v-for="(item, itemIndex) in comment.mailMessages"
                            :key="itemIndex">
                            <div class="mail-item-email">
                              {{item.recieverEmail}}
                            </div>
                            <div class="mail-item-status"
                              :class="getMailStatusTheme(item)">
                              {{getMailStatusMessage(item)}}
                              <i :class="getMailStatusIcon(item)"></i>
                              <div>
                                {{getSupportInoxMessage(item)}}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="comment-item-detail" v-if="isEmptyMailMessage()">
                          ไม่มี
                        </div>
                      </div>
                      <div class="comment-item-container small-device">
                        <div class="comment-item-header">ความคิดเห็น</div>
                        <div class="comment-item-detail">
                          {{ comment.comment }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </Section>
          </div>
        </div>
      </Page>
      <ErrorMessageCommentContainer
        v-if="loadCommentState.error"
        :error="loadCommentState.error"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import dateFormetter from '@/utils/dateFormatter';
import Page from '@/layouts/Page.vue';
import PreloaderSection from '@/components/PreloaderSection.vue';
import Section from '@/components/Section.vue';

import { loadCommentById } from './api';
import ErrorMessageCommentContainer from './ErrorMessageCommentContainer.vue';

export default {
  components: {
    PreloaderSection,
    ErrorMessageCommentContainer,
    Page,
    Section,
  },
  mixins: [dateFormetter],
  data() {
    return {
      comment: {
        name: null,
      },
      loadCommentState: {
        isLoading: false,
        error: null,
      },
    };
  },
  created() {
    this.load(this.commentId);
  },
  computed: {
    commentId() {
      return this.$route.params.commentId;
    },
  },
  methods: {
    async load(commentId) {
      this.loadCommentState.isLoading = true;
      try {
        const response = await loadCommentById(commentId);
        this.comment = response.data;
        this.loadCommentState.isLoading = false;
      } catch (error) {
        this.loadCommentState.error = error.response;
        this.loadCommentState.isLoading = false;
      }
    },
    isEmptyMailMessage() {
      if (this.comment.mailMessages) {
        if (this.comment.mailMessages.length === 0) {
          return true;
        }
        return false;
      }
    },
    getCommentCategoryName() {
      return _.get(this.comment.contactFormCategory, 'name', 'ไม่ระบุหัวข้อ');
    },
    getProgramTitle() {
      return _.get(this.comment.program, 'title', 'ไม่ระบุ');
    },
    getProgramCategoryName() {
      return _.get(this.comment, 'program.contentCategory.name', 'ไม่ระบุ');
    },
    getMailStatusTheme(mail) {
      if (mail.isSendFailed) return 'isSentFailed';
      if (mail.isSent) return 'isSentSuccess';
      if (mail.isPushedToQueue) return 'isSending';
      return 'isWaiting';
    },
    getMailStatusMessage(mail) {
      if (mail.isSendFailed) return 'ส่งไม่สำเร็จ';
      if (mail.isSent) return 'ส่งสำเร็จ';
      if (mail.isPushedToQueue) return 'อยู่ระหว่างการส่ง';
      return 'รอระบบทำการส่ง';
    },
    getSupportInoxMessage(mail) {
      if (this.getMailStatusMessage(mail) === 'ส่งไม่สำเร็จ') {
        return 'กรุณาติดต่อ support@inox.co.th';
      }
    },
    getMailStatusIcon(mail) {
      if (mail.isSendFailed) return 'fas fa-times-circle';
      if (mail.isSent) return 'fas fa-check';
      if (mail.isPushedToQueue) return 'far fa-paper-plane';
      return 'fas fa-hourglass-half';
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/form.scss';
@import './src/assets/scss/themes/components/section-container.scss';
.loading-state-container {
  margin-top: $spacer * 6;
}

.information {
  color: $gray-700;
}
.break {
  word-wrap: break-word;
  word-break: normal;
}

.name {
  margin-bottom: $spacer * 0.75;
}
.header {
  font-weight: bold;
}


.comment-item-container {
  margin-bottom: $spacer * 1.25;

  .comment-item-header {
    margin-bottom: $spacer * 0.25;
  }

  .comment-item-detail {
    color: $gray-700;
    font-weight: bold;
    word-wrap: break-word;
  }

  .mail-item-container {
    display: flex;
    justify-content: space-between;
    .mail-item-email{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .mail-item-status{
      margin-left: $spacer;
      white-space: nowrap;
      font-size: $font-size-sm;
      text-align:right;
    }
  }
}

.isSending {
  color: $info;
}
.isSentFailed {
  color: $danger;
}
.isSentSuccess {
  color: $success;
}
.isWaiting {
  color: $warning;
}

@media (min-width: 1023.98px) {
  .actions {
    .submitted-time {
      font-size: $font-size-base *1.25;
    }
  }
}

@media (min-width: 576px) {
  .title-container {
    .submitted-time-xs {
      display: none;
    }
  }
  .small-device {
    display: none;
  }
}
@media (max-width: 576px) {
  .actions {
    .submitted-time {
      display: none;
    }
  }
  .medium-device {
    display: none;
  }
}

</style>
